import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
  presentation: [],
  aitopic: [],
  quiz: [],
  intake: [],
  loaded: {
    presentation: false,
    aitopic: false,
    quiz: false,
    intake: false,
  },
  currentPage: {
    presentation: 0,
    aitopic: 0,
    quiz: 0,
    intake: 0,
  },
  searching: {
    search: "",
    presentation: {
      values: [],
      total: 0,
    },
    quiz: {
      values: [],
      total: 0,
    },
    intake: {
      values: [],
      total: 0,
    },
    aitopic: {
      values: [],
      total: 0,
    },
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
